<template>
    <div class="wrap">
        <loading></loading>
        <rotate-detect></rotate-detect><!--  template   -->
        <!--<div class="video_wrap" v-show="isPc">
            <youtube player-width="960" player-height="560" :video-id="videoId" :player-vars="{ autoplay: 0 }"  @ready="ready"></youtube>
            <div class="youtube_cover" v-on:click="showIndex('click')"></div>
        </div>-->
        <div class="topbar"></div>
        <div class="rightbar"></div>
        <div class="content">
            
            <nav-bar :nav="showNav"></nav-bar><!--  template   -->
            
            <index-sec1></index-sec1> <!--  template kv  -->
            <index-sec2 v-on:childOpen="videoFarther"></index-sec2> <!--  template about  -->
            <index-sec3></index-sec3> <!--  template artist  -->      
            <index-sec4></index-sec4> <!--  template start  -->
            <index-sec5></index-sec5> <!--  template history  -->
            <index-sec6></index-sec6> <!--  template blog  -->
            <index-sec7 v-on:childOpen="princeFarther"></index-sec7> <!--  template support  -->
            <index-sec8></index-sec8> <!--  template product  -->
            <index-sec9 v-on:childOpen="bookFarther"></index-sec9> <!--  template contact  -->
            <index-sec10></index-sec10> <!--  template google  -->
            <footer><p>© 2017 社團法人臺灣多寶格藝術發展協會 版權所有</p></footer>
            <booking :open="openBooking" v-on:close="bookFarther"></booking>
            <prince :open="openPrince" v-on:close="princeFarther"></prince>
            <popup :open="openVideo" v-on:close="videoFarther"></popup> 
            <reminder></reminder> 
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import ScrollReveal from 'scrollreveal'

    import 'jquery-easing'

    import VueYouTubeEmbed from 'vue-youtube-embed'
    
    import navBar from './common/Nav.vue'
    import rotateDetect from './common/RotateDetect.vue'
    import loading from './common/Loading.vue'

    import indexSec1 from './index/Kv.vue'
    import indexSec2 from './index/About.vue'
    import indexSec3 from './index/Artist.vue'
    import indexSec4 from './index/Start.vue'
    import indexSec5 from './index/History.vue'
    import indexSec6 from './index/Blog.vue'
    import indexSec7 from './index/Support.vue'
    import indexSec8 from './index/Product.vue'
    import indexSec9 from './index/Contact.vue'
    import indexSec10 from './index/Google.vue'
    import booking from './index/Booking.vue'
    import prince from './index/Prince.vue'
    import popup from './index/Popup.vue'
    import reminder from './common/Reminder.vue'

    Vue.use(VueYouTubeEmbed);

    export default {
        data: function() {
            return {
                videoId: 'AkL805Ar9fQ',
                isPc:true,
                isSafari:false,
                openBooking: false,
                openPrince: false,
                openVideo: false,
                showNav:true
            }
        },
        components: {
            loading,
            navBar,
            rotateDetect,
            indexSec1,
            indexSec2,
            indexSec3,
            indexSec4,
            indexSec5,
            indexSec6,
            indexSec7,
            indexSec8,
            indexSec9,
            indexSec10,
            booking,
            prince,
            popup,
            reminder
        },
        beforeMount:function(){
          $('body,html').addClass('hh');
        },
        updated:function(){
            console.log(this.isPc);
        },
        mounted: function(){
            var $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
            var ua = navigator.userAgent.toLowerCase(); 
            if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') <= -1) { 
                this.isSafari = true;
            }
            var $this = this;

            // if(this.detectmob()){
            //     this.isPc=false;  
            //     $(window).on('load',function(){
            //         $this.showIndex(); 
            //     })
            // }
            $(window).on('load',function(){
                $('.loading').fadeOut(600,function(){
                    $this.showIndex();
                });
                 
            })

            window.sr = ScrollReveal({ reset: true });
            var vv = function(ele,dur,del){
                sr.reveal(ele, { 
                    origin: 'bottom',
                    duration: dur,
                    delay: del,
                    opacity: 0,
                    scale: 1,
                    easing: 'cubic-bezier(0.42, 0, 0.58, 1)',
                    // mobile: true
                });
            }

            var vv_call = function(ele,add){
                sr.reveal(ele, { 
                    duration: 300,
                    scale: 1,
                    reset: false,
                    afterReveal: function (domEl) { 
                      $(domEl).addClass(add);
                    },
                    afterReset: function(domEl) {
                      $(domEl).removeClass(add).removeClass('down');
                    }
                });
            }

            vv('.wow1',500,0);
            vv('.wow2',500,200);
            vv('.wow3',500,400);
            vv('.wow4',500,600);
            vv('.wow5',500,800);
            vv('.wow6',500,1000);
            vv_call('.item','grow');


            var str = window.location.hash;
            if(str.match('from_artist') != null){
                // $('.worklist').slick('reinit');
                console.log('來自創作人');
                window.history.pushState(null, null, "/#/");
                setTimeout(function(){
                    $this.showIndex();
                    $body.animate({scrollTop:$('section.artist').offset().top },1000,'easeInQuart');
                },2500);
            }

            $('.logo').on('click',function(){
                console.log('在首頁');
                if($('.booking.open').size()>0){
                    console.log('預約有開');
                    $this.bookFarther();
                    setTimeout(function(){
                      $body.animate({scrollTop:0 },1000,'easeInQuart');
                    },600)
                }
                if($('.prince.open').size()>0){
                    console.log('小王子有開');
                    $this.princeFarther();
                    setTimeout(function(){
                      $body.animate({scrollTop:0 },1000,'easeInQuart');
                    },600)
                }
                else{
                    console.log('普通返回');
                    $body.animate({scrollTop:0 },800,'easeInQuart');
                }
                gaclick('btn_logo');
            });
            gapage('pv_home');
            document.addEventListener('contextmenu', event => event.preventDefault());
        }, 
        beforeDestroy:function(){
             $(window).off('load');
             document.removeEventListener('contextmenu', event => event.preventDefault());
        },
        methods:{
            method:function (url) {
              this.videoId = this.$youtube.getIdFromURL(url)
              this.startTime = this.$youtube.getTimeFromURL(url)
            },
            ready:function (player) {
               this.playing(player);
            //    console.log(player+'ready');
            },
            playing:function (player) {
                var $this =this;
                // console.log(player);
                $('.video_wrap>div').animate({opacity:1},100);
                player.playVideo();
                setTimeout(function(){
                    $this.showIndex();
                },14500) //14500
            },
            showIndex:function(val){
                if(val=="click" && !this.isSafari ){
                    console.log('chrome click');
                    return;
                }
                console.log('showIndex function');
                $('body,html').removeClass('hh');
                $('.video_wrap').fadeOut().html('');
                $('.loading').fadeOut();
                
                // $('.video_wrap').fadeOut();
                setTimeout(function(){
                    // $('.indexmenu,.maintitle').addClass('show'); 
                    sr.reveal('.index', { 
                        duration: 50,
                        scale: 1,
                        opacity: 1,
                        reset: true,
                        afterReveal: function (domEl) { 
                          $('.indexmenu,.maintitle').addClass('show');
                        },
                        afterReset: function(domEl) {
                          $('.indexmenu,.maintitle').removeClass('show');
                        }
                    });
                },600)
            },
            banana:function(){
                var i = 1;
                var inter = setInterval(function(){
                  if(i==4) {clearInterval(inter); return false;}
                  var b = '.b'+i;
                  var bb = '.b'+(i+1);
                  $(b).hide();
                  $(bb).show();
                  i++;
                },1000)
            },
            bookFarther:function(){
                this.openBooking = !this.openBooking;
                this.showNav = !this.showNav;
                var scrollFix = function(){
                    $(this).scrollTop( scroll_num );
                }
                if(this.openBooking == false){
                    // $('body,html').removeClass('hh');
                    console.log('from_artist');
                    $(window).off('scroll');
                }else{
                    // $('body,html').addClass('hh');
                    var scroll_num = $(window).scrollTop();
                    $(window).on('scroll',scrollFix);
                }
            },
            princeFarther:function(){
                this.openPrince = !this.openPrince;
                this.showNav = !this.showNav;
                var scrollFix = function(){
                    $(this).scrollTop( scroll_num );
                }
                if(this.openPrince == false){
                    $(window).off('scroll');
                }else{
                    var scroll_num = $(window).scrollTop();
                    $(window).on('scroll',scrollFix);
                }
            },
            videoFarther:function(){
                console.log('father got form video');
                this.openVideo = !this.openVideo;
            },
            logoClick:function(){
            // 在首頁
                if($('.index').size()>0){
                  $('.arrow_back').trigger('click');
                  console.log('在首頁');
                  var $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
                  setTimeout(function(){
                    $body.animate({scrollTop:0 },1000,'easeInQuart');
                  },800)
                }
                //在創作人
                else{
                    window.location="/#/?from_artist";
                }
                gaclick('btn_logo');
              
            },
            detectmob:function() { 
                if( navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)
                ){
                    return true;
                }
                else {
                    return false;
                }
            },
            msieversion:function(){
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf("MSIE ");

                if (msie > 0) 
                {
                    // alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
                }
                else  
                {
                    // alert('otherbrowser');
                }
                return false;
            }

            
        }

    }
</script>

<style>
    @import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css';
</style>


// WEBPACK FOOTER //
// Index.vue?f2a1b374